//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            insurancePlans: [],
            insurance: {
                rental_insurance_id: ''
            },
            planError: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;
        Event.$on('change-insurance-plan', function (item) {
            $el.insurance = item;
            $el.insurance.rental_insurance_id = { 'id': _this.insurance.pivot.id, 'name': _this.insurance.title };
            $el.$children[0].$data.showSmallModal = true;
        });
        axios.get("/prototype/property/rental-insurance").then(function (response) {
            response.data.forEach(function (insurance) {
                $el.insurancePlans.push({
                    name: insurance.title,
                    id: insurance.id
                });
            });
        });
    },

    methods: {
        updatePlan: function updatePlan() {
            var _this2 = this;

            if (!this.insurance.rental_insurance_id.id) {
                this.planError = true;
                return;
            }
            this.planError = false;
            this.insurance.rental_insurance_id = this.insurance.rental_insurance_id.id;
            this.insurance.insurance_id = this.insurance.pivot.id;
            axios.post('/prototype/resident/update-insurance-plan', this.insurance).then(function (response) {
                _this2.$snotify.success('The Insurance was updated');
                Event.$emit('get-resident-rental-insurance');
                Event.$emit('close-small-modal');
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentChangeInsurancePlan.vue
// module id = Mkjm
// module chunks = 0 1